<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      :disable-resize-watcher="true"
      :color="color === 'transparent' ? 'primary' : color"
      temporary
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title"
              ><v-img
                src="@/assets/flety_600.png"
                alt="Logo"
                class="mr-16"
                max-width="130"
            /></v-list-item-title>
            <!-- <v-list-item-subtitle>Ridery</v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />
      <v-list dense nav>
        <v-list-item link>
          <v-list-item-content>
            <v-list-item>
              <v-list-item-content
                class="color-white-text text-xl font-weight-bold"
                @click="$router.push({ name: 'links' })"
              >
                Inicio / Entrar
              </v-list-item-content>
            </v-list-item>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item link>
          <v-list-item-content>
            <v-list-item >
              <v-list-item-content
                class="color-white-text text-xl font-weight-bold"
              >
                Empresas transporte
              </v-list-item-content>
            </v-list-item>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-content>
            <v-list-item >
              <v-list-item-content
                class="color-white-text text-xl font-weight-bold"
              >
                Generadores de carga
              </v-list-item-content>
            </v-list-item>
          </v-list-item-content>
        </v-list-item> -->
        <v-list-item link v-if="false">
          <v-list-item-content>
            <v-list-item>
              <v-list-item-content
                class="color-white-text text-xl font-weight-bold"
              >
                ES
              </v-list-item-content>
            </v-list-item>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app height="72" :color="color" :flat="flat">
      <v-container
        class="d-flex flex-row justify-lg-space-between align-center"
      >
        <v-toolbar-title
          ><v-img
            src="@/assets/flety_600.png"
            max-width="130"
            v-show="fab"
          ></v-img
        ></v-toolbar-title>
        <v-spacer></v-spacer>
        <span v-if="$vuetify.breakpoint.mdAndUp">
          <!-- <v-btn
            text
            color="white"
            class="font-weight-bold"
            href="https://api.whatsapp.com/send?phone=584129227567&text=%C2%A1Hola%20Flety!%20Necesito%20informaci%C3%B3n"
            target="_blank"
            id="app_bar_whatsapp"
          >
            <v-icon>mdi-whatsapp</v-icon> +58 412-922-75-67
          </v-btn> -->
          <v-btn
            id="btn-ingresar"
            v-on:click="trackBtnIngresar()"
            text
            color="white"
            @click="$router.push({ name: 'links' })"
            class="font-weight-bold"
          >
            Inicio / Entrar
          </v-btn>
          <template v-if="false">
            <v-divider class="ml-2" vertical></v-divider>
            <v-btn
              v-on:click="trackBtnIdioma()"
              id="btn-idioma-spanish"
              class="ml-2 font-weight-bold"
              text
              color="white"
            >
              ES
            </v-btn>
          </template>
        </span>
        <span v-else>
          <v-app-bar-nav-icon color="white" @click="drawer = !drawer">
            <template #default>
              <span v-if="!drawer" class="">
                <v-icon x-large> mdi-menu</v-icon>
              </span>
              <span v-else> <v-icon x-large> mdi-close</v-icon> </span>
            </template>
          </v-app-bar-nav-icon>
        </span>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  props: {
    color: String,
    flat: Boolean,
    fab: Boolean,
  },
  data() {
    return {
      drawer: false,
    };
  },
  computed: {
    computedMdAndUp() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },
  watch: {
    computedMdAndUp(newVal) {
      if (newVal) {
        this.drawer = false;
      }
    },
  },
  methods: {
    trackBtnIdioma() {
      this.$gtag.event("btn_idioma_spanish", {
        event_category: "btn",
        event_label: "btn_idioma_spanish",
        value: "btn_idioma_spanish",
      });
    },
    trackBtnIngresar() {
       this.$gtag.event("btn_ingresar", {
        'event_category': "btn",
        'event_label': "btn_ingresar",
        'value': "btn_ingresar"
      })
    }
  },
};
</script>

<style></style>
